import React from 'react';
type SectionHeadingProps = {
  kicker?: string;
  title: React.ReactNode;
  sub?: React.ReactNode;
  tone?: 'light' | 'dark';
};
export function SectionHeading({
  kicker,
  title,
  sub,
  tone = 'light'
}: SectionHeadingProps) {
  const dark = tone === 'dark';
  return <div className="mx-auto max-w-3xl text-center" data-id="element-53" data-mp="3f3gdgxx6dg8m">
      {kicker && <p className={`text-xs font-bold uppercase tracking-[0.16em] ${dark ? 'text-blush' : 'text-cta'}`} data-id="element-54" data-mp="3k0f7zhkr3p7c">{kicker}</p>}
      <h2 className={`mt-3 font-serif text-[30px] font-bold leading-[1.12] sm:text-4xl md:text-5xl ${dark ? 'text-cream' : 'text-forest'}`} data-id="element-55" data-mp="gjgl6zpxdmp6">
        {title}
      </h2>
      {sub && <p className={`mt-4 text-base leading-relaxed sm:text-lg ${dark ? 'text-cream/80' : 'text-muted'}`} data-id="element-56" data-mp="1spslpgiejl0">{sub}</p>}
    </div>;
}